import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import ScreeningView from '@/views/ScreeningView.vue'
import Login from '@/views/AppLogin.vue'
import { GRADE_TYPE } from '@/constants/router/contract'
import { ROUTER_PATHS } from '@/constants/router/paths'
import { ROUTER_NAMES } from '@/constants/router/names'
import { useRouterStore } from '@/stores/routerStore'
import { storeToRefs } from 'pinia'
import { authGuard } from './guard'

const routes: RouteRecordRaw[] = [
  {
    path: ROUTER_PATHS.login,
    name: ROUTER_NAMES.login,
    component: Login,
    meta: {
      requiresAuth: false, // [MiiaFW] 認証必須フラグ
      requiredGrade: GRADE_TYPE.free
    }
  },
  {
    path: ROUTER_PATHS.screening,
    name: ROUTER_NAMES.screening,
    component: ScreeningView,
    meta: {
      requiresAuth: true, // [MiiaFW] 認証必須フラグ
      requiredGrade: GRADE_TYPE.premiere
    },
    beforeEnter: authGuard
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: () => {
      return { name: ROUTER_NAMES.screening }
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes
})

router.beforeEach((_to, from, next) => {
  const routerStore = useRouterStore()
  const { previousPath } = storeToRefs(routerStore)
  previousPath.value = from.matched.length === 0 ? from.path : from.matched[0].path
  next()
})

export default router
